/** JS Date to ISO Y-m-d */
export const dateToISOYmd = (date: Date) => date.toISOString().substring(0, 10);
/** JS Date local time to format d/m/Y H:i */
export const dateToDMYHi = (date: Date) =>
    `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;

const FRENCH_MONTHS = [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
] as const;

const getMonthInFrench = (index: number) => FRENCH_MONTHS[index];

/** JS Date to french format */
export const dateToFrenchFormat = (date: Date) => {
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const month = getMonthInFrench(monthIndex);
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
};

export const isWithinWorkingHours = (startMinutes: number, endMinutes: number): boolean => {
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    // const startMinutes = 8 * 60 + 30; // 8h30
    // const endMinutes = 18 * 60; // 18h00
    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
};

export function parseDateSafe(dateStr: string): Date | null {
    let date = new Date(dateStr);
    if (!Number.isNaN(date.getTime())) {
        return date;
    }
    let cleaned = dateStr.replace(/\.(\d{3})\d*/, '.$1');

    if (cleaned.endsWith('+00:00Z')) {
        cleaned = cleaned.replace('+00:00Z', 'Z');
    }
    date = new Date(cleaned);

    return Number.isNaN(date.getTime()) ? null : date;
}

export function timeAgo(date: Date): string {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    if (diffMs < 0) return "à l'instant";

    const seconds = Math.floor(diffMs / 1000);
    if (seconds < 60) return `il y a ${seconds} seconde${seconds > 1 ? 's' : ''}`;

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `il y a ${minutes} minute${minutes > 1 ? 's' : ''}`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `il y a ${hours} heure${hours > 1 ? 's' : ''}`;

    const days = Math.floor(hours / 24);
    if (days < 7) return `il y a ${days} jour${days > 1 ? 's' : ''}`;

    const weeks = Math.floor(days / 7);
    if (weeks < 5) return `il y a ${weeks} semaine${weeks > 1 ? 's' : ''}`;

    const months = Math.floor(days / 30);
    if (months < 12) return `il y a ${months} mois`;

    const years = Math.floor(days / 365);
    return `il y a ${years} an${years > 1 ? 's' : ''}`;
}

export const ONE_DAY_MS = 86_400_000;

const RELATIVE_DATE_LABELS = ["Aujourd'hui", 'Demain', 'Hier'];

/**
 * Math.round absorbs DST gaps (±1h) so "Demain"/"Hier" survive clock changes.
 */
export const formatRelativeDate = (dateStr: string): string => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const date = new Date(dateStr);
    date.setHours(0, 0, 0, 0);
    const diff = Math.round((date.getTime() - now.getTime()) / ONE_DAY_MS);
    if (diff === 0) return "Aujourd'hui";
    if (diff === 1) return 'Demain';
    if (diff === -1) return 'Hier';
    return new Date(dateStr).toLocaleDateString();
};

export const formatDateWithArticle = (dateStr: string): string => {
    const label = formatRelativeDate(dateStr);
    return RELATIVE_DATE_LABELS.includes(label) ? label : `le ${label}`;
};
